export function triggerReportPrint(): void {
  if (typeof window === 'undefined' || typeof window.print !== 'function') {
    return
  }

  window.print()
}
